export const matchesNavigationPath = (currentPath, route) =>
  currentPath === route || currentPath.startsWith(`${route}/`);
